import React from 'react'

import { Pill, Spacer } from 'component-library-next'
import dayjs from 'dayjs'

import { IdentifiedClause } from '@app/graphql/types'
import { TemplateCollectionQuery } from '@app/queries/TemplateCollection/TemplateCollection.queries'

import './RenovationClause.scss'

type Props = {
  clause: IdentifiedClause
  documentDate?: Date
  addTemplate?: (findingsText: any, recommendationsText: any) => void
  templates?: Exclude<TemplateCollectionQuery['templateCollection']['templates'], null | undefined>
  hasEditor: boolean
}

export const clauseTypeTranslations = {
  deadline: 'Fristenklausel',
  scope: 'Umfangsklausel',
  workmanship: 'Ausführungsklausel',
  colour: 'Farbwahlklausel',
  finalRenovation: 'Endrenovierungsklausel',
  transfer: 'Übertragungsklausel',
  wallpaper: 'Tapetenklausel',
  material: 'Materialklausel',
  compensation: 'Abgeltungsklausel',
  renovation: 'Sanierungsklausel',
  holes: 'Löcherklausel',
  date: 'Datumsklausel',
  originalCondition: 'Übernahmezustandsklausel',
  wood: 'Holzklausel',
  consultation: 'Rückspracheklausel',
  paymentDeadline: 'Zahlungsfristklausel',
  nailHookScrew: 'Nägel-Haken-Schrauben-Klausel'
}

export const RenovationClause = ({
  clause,
  addTemplate,
  templates,
  hasEditor,
  documentDate
}: Props) => {
  const getStructuredTextForAddTemplate = (
    template?: Exclude<
      TemplateCollectionQuery['templateCollection']['templates'],
      null | undefined
    >[number]
  ) => {
    addTemplate &&
      template &&
      addTemplate(
        template.fields.find((field) => field.name === 'findings')?.text,
        template.fields.find((field) => field.name === 'recommendations')?.text
      )
  }

  const template = (templates || []).find((template) => template.uid === clause.type)

  const isImportantClause = (clause: IdentifiedClause): boolean => {
    const importantClauses = Object.keys(clauseTypeTranslations).slice(0, 7)
    return importantClauses.indexOf(clause.type) !== -1
  }

  return (
    <React.Fragment key={clause.type}>
      <div className='mecl-clauses__clause'>
        <React.Fragment>
          <Pill color={isImportantClause(clause) ? Pill.colors.warning : Pill.colors.black}>
            {clauseTypeTranslations[clause.type]}
          </Pill>
        </React.Fragment>
        {documentDate && clause.type === 'deadline' ? (
          <Pill marginLeft={true} invert={true}>
            Vertragsabschluss: {dayjs(documentDate).format('DD.MM.YYYY')}
          </Pill>
        ) : (
          ''
        )}
      </div>
      <div className='mecl-clauses__paragraph'>
        {clause.spans.map((span, index) => (
          <React.Fragment key={index}>
            <Pill
              color={isImportantClause(clause) ? Pill.colors.warning : Pill.colors.black}
              marginBothSide={true}
            >
              S.{span.page}
            </Pill>
            <p className='mecl-clauses__paragraph'>{span.text}</p>
          </React.Fragment>
        ))}
      </div>
      {addTemplate && hasEditor && template && (
        <span
          onClick={() => getStructuredTextForAddTemplate(template)}
          className='mecl-clauses__paragraph--add-template-button'
        >
          Antwortvorlage einfügen
        </span>
      )}
      <Spacer />
    </React.Fragment>
  )
}
